import { CHARTER_FLIGHT_DETAILS } from 'constants/charterFlight'
import { isFlightItem } from 'lib/checkout/checkoutUtils'
import { isCharterDepartureOutOfSystemRange } from 'lib/flights/charterBookingWindow'

/** Remove only unselected domestic connections that cannot yet be booked. */
export function removeUnavailableCharterConnections(
  items: Array<App.Checkout.AnyItem>,
  mode?: App.CheckoutCartMode,
): Array<App.Checkout.AnyItem> {
  if (mode && mode !== 'default') return items

  const charters = items.filter(isFlightItem).filter(item =>
    item.charterBundleRoute && isCharterDepartureOutOfSystemRange(item.flights[0]?.departingDate),
  )
  if (!charters.length) return items

  const repriceCharterIds = new Set<string>()
  const remainingItems = items.filter(item => {
    if (!isFlightItem(item) || item.charterBundleRoute || item.flights.length) return true

    const charter = charters.find(charter => {
      const route = CHARTER_FLIGHT_DETAILS[charter.charterBundleRoute!]
      const isConnection = (item.destinationAirportCode === route.originAirport.airportCode &&
        item.originAirportCode !== route.destinationAirport.airportCode) ||
        (item.originAirportCode === route.originAirport.airportCode &&
          item.destinationAirportCode !== route.destinationAirport.airportCode)
      const connectionOrigin = item.destinationAirportCode === route.originAirport.airportCode
        ? item.originAirportCode : item.destinationAirportCode
      const matchesCustomerOrigin = !charter.customerOriginAirportCode || connectionOrigin === charter.customerOriginAirportCode
      return isConnection && matchesCustomerOrigin && item.bundledItemIds?.some(id => charter.bundledItemIds?.includes(id))
    })
    if (!charter) return true

    if (item.bundleBudget) repriceCharterIds.add(charter.itemId)
    return false
  })

  if (remainingItems.length === items.length) return items

  // The normal checkout fare loader will reprice any affected charter without its feeder budget.
  return remainingItems.map(item => repriceCharterIds.has(item.itemId) ? {
    ...item,
    hasFinalFare: false,
    fetchingFare: false,
    fareFetchError: undefined,
  } : item)
}
